import React from 'react';
import { IconContext } from 'react-icons';
import { IconProps } from './createIconComponent';
import './style.css';

export type { IconProps };

export { ConditionalIcon } from './ConditionalIcon';
export * from './icons';
export { IconSwitch } from './IconSwitch';

type ProviderProps = React.ComponentProps<typeof IconContext.Provider>;

export const Provider: React.FC<React.PropsWithChildren<ProviderProps>> = ({
  children,
  ...props
}) => {
  return <IconContext.Provider {...props}>{children}</IconContext.Provider>;
};

export type IconComponent = React.ComponentType<React.PropsWithChildren<IconProps>>;
